import { useContext } from "react";

import type { ICallAssistantTourContext } from "@/contexts/CallAssistantTourContext";
import { CallAssistantTourContext } from "@/contexts/CallAssistantTourContext";

export const useCallAssistantTour = (): ICallAssistantTourContext => {
  const context = useContext(CallAssistantTourContext);

  // NOTE: this guard ensures the hook is used within its required provider and does not need test coverage.
  /* istanbul ignore next */
  if (context === null) {
    throw new Error(
      "useCallAssistantTour must be used within a CallAssistantTourProvider",
    );
  }
  return context;
};
